class AdminController {
    constructor(DynamicMenuServiceApi, $uibModal, $window, $browser) {
        this.$onInit = () => {
            this.init();
        };
        this.init = () => {
            this.data = {
                messages: ''
            };
            /*
                NOTE: The menuItems are trimmed on the server for the Admin and Support Roles
                NOTE: The ManageSysAlert and Uploads menu items and link list items
                        are inserted manually at the end of the list generated from menuItems
                        Admin always gets the ManageSysAlert item
                        Support gets Uploads if web.config UploadModule flag is true
            */
            this.DynamicMenuServiceApi.navItems()
                .then((response) => response.data)
                .then((menuItems) => this.menuItems = menuItems);
        };
        this.relocate = (cLocation) => {
            this.window.location.replace(this.browser.baseHref() + cLocation);
        };
        this.DynamicMenuServiceApi = DynamicMenuServiceApi;
        this.uibModal = $uibModal;
        this.window = $window;
        this.browser = $browser;
    }
}
angular.module('app').component('admin', {
    bindings: {},
    templateUrl: 'scripts/app/partials/Admin/admin.tpl.html',
    controllerAs: 'vm',
    controller: AdminController
});
